import { registerValidators } from '../components/Form'
import { photoUploader } from '../components/Photos'

export function requestEstimationPage() {
    photoUploader()
    registerValidators()
}
